import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ReceiptLongOutlinedIcon, ChevronRightIcon } from "./icons";
import useGoTo from "../hooks/useGoTo";

// Por quanto tempo depois do pedido a home oferece o acompanhamento.
const HOURS_VISIBLE = 3;

// Classe no <body> enquanto a faixa aparece: a barra de categorias, que
// também gruda no topo, passa a grudar logo abaixo dela (mobile.css).
export const ORDER_BANNER_CLASS = "has-order-banner";

/**
 * Faixa no topo da home com o pedido recente. Fica presa no topo enquanto a
 * home rola, para o acompanhamento estar sempre à mão. Antes era um botão
 * vermelho flutuante que cobria o cardápio e brigava com a barra da sacola.
 */
export default function StatusButton() {
  const goTo = useGoTo();
  const lastCache = useSelector((state) => state.checkout.lastCheckoutCache);
  // 36e5 is the scientific notation for 60*60*1000
  const isVisible =
    !!lastCache &&
    (new Date() - new Date(lastCache.createdAt)) / 36e5 <= HOURS_VISIBLE;

  useEffect(() => {
    if (!isVisible) return;
    document.body.classList.add(ORDER_BANNER_CLASS);
    return () => document.body.classList.remove(ORDER_BANNER_CLASS);
  }, [isVisible]);

  if (!isVisible) return null;

  const handleClick = () => goTo(`/status/${lastCache.shortReference}`);

  return (
    <button type="button" className="order-banner" onClick={handleClick}>
      <ReceiptLongOutlinedIcon fontSize="small" />
      <span className="order-banner__text">
        Pedido nº {lastCache.shortReference} em andamento
      </span>
      <span className="order-banner__action">
        Acompanhar
        <ChevronRightIcon fontSize="small" />
      </span>
    </button>
  );
}
